import { render, staticRenderFns } from "./RateTypeDropdown.vue?vue&type=template&id=23447a20"
import script from "./RateTypeDropdown.vue?vue&type=script&lang=js"
export * from "./RateTypeDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports